<template>
  <div class="field-lines-viz">
    
    <div class="viz-header" >
      <div class="brief" v-latex="knowledgePoint"></div>
      <div class="formula" v-latex><strong>公式：</strong>详见下方原理说明</div>
    </div>

    <div class="main-canvas">
      <svg width="100%" height="400" viewBox="0 0 400 400">
        <!-- 样式定义 -->
        <defs>
          <marker id="arrow-field" markerWidth="8" markerHeight="6" refX="8" refY="3" orient="auto">
            <polygon points="0 0, 8 3, 0 6" fill="#00d2ff" />
          </marker>
        </defs>

        <!-- 直导线磁场 (右手螺旋定则) -->
        <g v-if="currentType === 'straight'">
          <!-- 导线 -->
          <line x1="200" y1="50" x2="200" y2="350" stroke="#aaa" stroke-width="8" />
          <line x1="200" y1="50" x2="200" y2="350" stroke="#ff4757" stroke-width="2" stroke-dasharray="10,5">
            <animate attributeName="stroke-dashoffset" from="100" to="0" dur="2s" repeatCount="indefinite" />
          </line>
          <!-- 磁感线 (同心圆) -->
          <g v-for="r in [40, 70, 100]" :key="r">
            <ellipse cx="200" cy="200" :rx="r" :ry="r/3" fill="none" stroke="#00d2ff" stroke-width="1.5" opacity="0.6" marker-end="url(#arrow-field)" />
          </g>
        </g>

        <!-- 环形电流 -->
        <g v-if="currentType === 'loop'">
          <ellipse cx="200" cy="200" rx="80" ry="30" fill="none" stroke="#ff4757" stroke-width="4" />
          <!-- 磁感线 (穿过环心) -->
          <path d="M 200 100 Q 250 200 200 300" fill="none" stroke="#00d2ff" opacity="0.6" marker-end="url(#arrow-field)" />
          <path d="M 200 100 Q 150 200 200 300" fill="none" stroke="#00d2ff" opacity="0.6" marker-end="url(#arrow-field)" />
          <line x1="200" y1="120" x2="200" y2="280" stroke="#00d2ff" stroke-width="2" marker-end="url(#arrow-field)" />
        </g>

        <!-- 螺线管 -->
        <g v-if="currentType === 'solenoid'">
          <!-- 磁感线 -->
          <g v-for="i in [-40, -20, 0, 20, 40]" :key="i">
             <path :d="`M 100 ${200+i} L 300 ${200+i}`" fill="none" stroke="#00d2ff" stroke-width="1" opacity="0.8" marker-end="url(#arrow-field)" />
          </g>
          <!-- 外部闭合线 -->
          <path d="M 300 180 Q 200 100 100 180" fill="none" stroke="#00d2ff" opacity="0.4" />
          <!-- 螺线管线圈 -->
          <path v-for="j in 8" :key="j" :d="`M ${80 + j*30} 170 Q ${95 + j*30} 140 ${110 + j*30} 170`" fill="none" stroke="#aaa" stroke-width="4" />
        </g>
      </svg>
    </div>

    <div class="rule-hint">
       <span class="badge">右手螺旋定则</span>
       {{ ruleText }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'FieldLinesViz',
  props: { knowledgePoint: { type: String, default: '' } },
  data() {
    return {
      currentType: 'straight'
    }
  },
  computed: {
    ruleText() {
       if(this.currentType === 'straight') return "大拇指指向电流方向，四指弯曲方向即为磁感线方向。";
       return "四指弯曲方向即为电流方向，大拇指指向内部磁感线方向。";
    }
  }
}
</script>

<style scoped lang="scss">
.field-lines-viz { width: 100%; color: #fff; display: flex; flex-direction: column; gap: 15px; }
.viz-header { display: flex; justify-content: space-between; padding: 10px; background: rgba(255,255,255,0.05); border-radius: 4px; .title { color: #00d2ff; font-weight: bold; } }
.main-canvas { background: #0a0a0a; border-radius: 8px; }
.rule-hint { padding: 10px; background: rgba(0, 210, 255, 0.1); border-radius: 4px; font-size: 0.9rem; .badge { background: #00d2ff; color: #000; padding: 2px 6px; border-radius: 4px; margin-right: 8px; font-weight: bold; } }
</style>
